// react components
import React from 'react'
import {
    useDispatch,
} from 'react-redux'
import TextareaAutosize from 'react-textarea-autosize'

// data
import {
    reduxModalErrorEventHandlerSite,
} from 'data'

// pages
import {
    ErrorHelper825,
    FormLabel825,
} from 'pages'

// serializer
import {
    TranslationHelper,
} from 'serializers/site'

// props
type TextAreaInputV2825Props = {
    directionRtl?: boolean
    disabled?: boolean
    error?: string
    helperText?: string
    label?: string
    marginBottom?: number
    name: string
    noLineBreak?: boolean
    onChange: any
    onRefresh?: () => void
    placeholder?: string
    translation?: TranslationHelper
    value: string
}

// main
export const TextAreaInputV2825: React.FC<TextAreaInputV2825Props> = React.memo(({
    directionRtl,
    disabled,
    error,
    helperText,
    label,
    marginBottom,
    name,
    noLineBreak,
    onChange,
    onRefresh,
    placeholder,
    translation,
    value,
}) => {

    const dispatch = useDispatch()

    function onInputChange(value: string | null | undefined) {
        try {
            if (noLineBreak && value) {
                value = value.replace(/\n/g, ' ').trim()
            }
            onChange({
                name: name,
                value: value,
            })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TextAreaInputV2825',
                'onInputChange',
            ))
        }
    }

    if (label || translation) {
        return (
            <div
                className={`input-wrap-825${disabled ? ' disabled' : ''}`}
                style={{
                    marginBottom: marginBottom ? `${marginBottom}px` : undefined,
                }}
            >
                <div className='input-label-wrap'>
                    <FormLabel825
                        formInput='textArea'
                        helperText={helperText}
                        label={label || ''}
                        name={name}
                        onRefresh={onRefresh}
                        translation={translation}
                        translationDefaultValue={value}
                    />
                </div>
                <TextareaAutosize
                    className={`text-area-input-825${directionRtl ? ' rtl' : ''}`}
                    disabled={disabled}
                    name={name}
                    onChange={(e) => onInputChange(e.target.value)}
                    placeholder={placeholder}
                    rows={1}
                    value={value}
                />
                <ErrorHelper825 error={error} />
            </div>
        )
    }

    return (
        <>
            <TextareaAutosize
                className={`text-area-input-825${directionRtl ? ' rtl' : ''}`}
                disabled={disabled}
                name={name}
                onChange={(e) => onInputChange(e.target.value)}
                placeholder={placeholder}
                rows={1}
                value={value}
            />
            {marginBottom && (
                <div
                    style={{
                        marginBottom: `${marginBottom}px`,
                    }}
                />
            )}
        </>
    )
})
